import { React, useState, useEffect } from "react";
import "./WalletContentComponent.scss";

import DateModalRange from "../../../../../containers/logged_user_components/user_refer_earn/referalList/dateModalRange/DateModalRange";

// Redux
import { connect } from "react-redux";
import uiActions from "../../../../../redux/ui/action";
// Router
import { Link, useHistory } from "react-router-dom";
// images
import images from "../../../../../utilities/images/images";
import calender from "../../../../../utilities/images/refer&earn/calender.png";
import { Col, Row } from "react-bootstrap";
import { url_175, url_176 } from "../../../../../custom_utilities/api_services";
import axios from "axios";
import { isEmpty } from "../../../../../custom_utilities/custom_useful_functions";

const WalletContentComponent = (props) => {
  let { history, userPreference, startLoading, finishLoading, token, tokenType} = props;
  const historyState = useHistory();
  const [state, setState] = useState({
    coinData: {},
    coinUsesPoints: [],
    coinEarnPoints: [],
    pageNo: 1,
    transaction_data: [],
    showAllTransactions: true,
  });

  const [refer, setRefer] = useState({
    updatedTransactionList: [],
    transaction_data: [],
    open: false,
  });

  const [range, setRange] = useState([
    {
      startDate: "",
      endDate: "",
      key: "selection",
    },
  ]
  );

  const transactionApi = async (pageNo = state.pageNo) => {
    startLoading();
    try {
      const response = await axios.get(url_176 + `?page=${pageNo}`);
      console.log("transactionApi", response);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => {
          return {
            ...prevState,
            pageNo: response.data.transaction_data.current_page,
            coinData: response.data.consolidated_coins,
            transaction_data: [
              ...prevState.transaction_data,
              ...response.data.transaction_data.data,
            ],
            showAllTransactions:
              response.data.transaction_data.data.length < 5 ? false : true,
          };
        });
      } else {
        finishLoading();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const coinUsesApi = async () => {
    startLoading();
    try {
      const response = await axios.get(url_175);
      if (response.data.status === 200) {
        finishLoading();
        console.log(response.data.Uses);
        setState((prevState) => {
          return {
            ...prevState,
            coinUsesPoints: response.data.Uses,
            coinEarnPoints: response.data.data,
          };
        });
      } else {
        finishLoading();
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  };
  

  useEffect(() => {
    coinUsesApi();
    transactionApi();
    initialTransaction();
  }, []);

  const handleShowModal = () => {
    setRefer((prevState) => ({
      ...prevState,
      open: true,
    }));
  };

  const handleCloseModal = () => {
    setRefer((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  useEffect(() => {
    getTransactionLists();
  }, [range[0].startDate, range[0].endDate]);

  const formatDate = (inputDateString) => {
    // Convert the input date string to a JavaScript Date object
    const date = new Date(inputDateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    return `${day}-${month}-${year}`;
  };

  const getTransactionLists = async () => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };

    const data = {
      start_date : formatDate(`${range[0].startDate}`),
      end_date : formatDate(`${range[0].endDate}`),
    };
    try {
      const response = await axios.post(`https://learning.motion.ac.in/motioneducation/api/wallet/get/user/transactionsall`, data, { headers });
      console.log(response.data.transaction_data.data);
      
      if (response.data.status === 200) {
        setRefer((prevState) => ({
          ...prevState,
          updatedTransactionList: response.data.transaction_data.data,
          transaction_data: []
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const initialTransaction = async (pageNo = state.pageNo) => {
    try {
      const response = await axios.get(url_176 + `?page=${pageNo}`);
      if (response.data.status === 200) {
        setRefer((prevState) => {
          return {
            ...prevState,
            transaction_data: 
              response.data.transaction_data.data
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const transactionConditionalList = (data) => {
    return (
        <div className="transaction">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <p className="coin_desc mb-0">{`Motion Coins ${
              data.trans_type === "E" ? "Earned" : "Used"
            }`}</p>
            <div className="d-flex align-items-center gap-2">
              <p
                className="coin_earn mb-0"
                style={{
                  color:
                    data.trans_type === "E"
                      ? "#3C9D00"
                      : "#000000",
                }}
              >{`${data.trans_type === "E" ? "+" : "-"} ${
                data.coins
              }`}</p>
              <img src={images.motionCoin} width={25} />
            </div>
          </div>
          <div className="d-flex transaction_detail">
            <p className="mb-0">{`Date : ${data.coin_date}`}</p>
            <p className="mb-0">{`Activity : ${data.description}`}</p>
          </div>
        </div>
      )
  }

  return (
    <>
      <div className="wallet_wrapper">
        <div className="wallet_InrWrapper">
          <div className="container">
            <div className="wallet_contentWpr">
              <div className="walletTabBox">
                <div className="walletTab">
                  <button
                    className="walletBackBtn"
                    onClick={historyState.goBack}
                  >
                    <img src={images.backBtn} width={30} />
                  </button>
                  <h3 className="text-center mb-4">Motion Wallet</h3>
                  <div className="coinWalletWrapper mx-auto">
                    <Row>
                      <Col
                        lg={6}
                        md={6}
                        sm={6}
                        className="order-lg-first order-md-first order-sm-first order-last"
                      >
                        <div className="d-flex justify-content-center justify-content-md-start justify-content-lg-start  align-items-center h-100">
                          <div className="tmcoins_wrapper">
                            <p>Total Motion Coins :</p>
                            <div className="d-flex align-items-center gap-3">
                              <img src={images.motionCoin} width={50} />
                              <span>{state.coinData.current_coins}</span>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={6}
                        md={6}
                        sm={6}
                        className="order-lg-last order-md-last order-sm-last order-first"
                      >
                        <div className="w-75 mx-auto">
                          <img
                            className="img-fluid"
                            src={images.motionWallet}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="row coin_cards_wrapper">
                      <div className="col-6">
                        <div className="coin_cards">
                          <p>Coins Spent</p>
                          <div className="d-flex align-items-center gap-2">
                            <img src={images.motionCoin} width={30} />
                            <span>{state.coinData.total_spent}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="coin_cards">
                          <p>Coins Earned Today</p>
                          <div className="d-flex align-items-center gap-2">
                            <img src={images.motionCoin} width={30} />
                            <span>{state.coinData.total_todays_earnings}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="walletTransaction_container">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex gap-3">
                        <img src={images.transactions} width={30} />
                        <h3 className="mb-0"> Motion Wallet Transactions</h3>
                      </div>
                      <div>
                        <img
                          src={calender}
                          onClick={handleShowModal}
                          style={{ cursor: "pointer", width: "25px", height: "25px" }}
                          alt="calenderIcon"
                        />
                      </div>
                    </div>
                    <div className="walletTransaction_wrapper">
                      {(refer.transaction_data.length > 0) && ((refer.transaction_data).map((data) => transactionConditionalList(data))
                      )}
                      {(refer.updatedTransactionList.length > 0) && ((refer.updatedTransactionList).map((data) => transactionConditionalList(data))
                      )}
                      {!(refer.transaction_data.length > 0 || refer.updatedTransactionList.length > 0) && (
                        <p className="text-center">No Transaction Available</p>
                      )}
                      {state.showAllTransactions && (
                        <div className="text-center mt-4">
                          <button
                            className="transaction_btn"
                            onClick={() => transactionApi(state.pageNo + 1)}
                          >
                            View more Transactions
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="sec_seprator"></div>
                    <div className="useCoins_wrapper">
                      <ul>
                        {state.coinEarnPoints.map((points) => {
                          return (
                            <li
                              dangerouslySetInnerHTML={{ __html: points.value }}
                            ></li>
                          );
                        })}
                        {/* <li>Watching Subject Videos</li>
                                <li>Playing Motion Daily and Weekly Quizzes</li>
                                <li>Finishing Practice Sheets</li>
                                <li>Attending Motion Online Tests</li>
                                <li>Posting Doubts in Doubts Section</li>
                                <li>Purchasing Motion Products from Store</li>
                                <li>Referring your friends </li>
                                <li>Topping the weekly leaderboard</li> */}
                      </ul>
                    </div>
                    <div className="sec_seprator"></div>
                    <div className="useCoins_wrapper">
                      <ul>
                        {state.coinUsesPoints.map((points) => {
                          return (
                            <li
                              dangerouslySetInnerHTML={{ __html: points.value }}
                            ></li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DateModalRange
        open={refer.open}
        onClose={handleCloseModal}
        range={range}
        setRange={setRange}
       
      />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.authType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WalletContentComponent);
